import type { Product } from "../data/catalogue";

export function formatGbp(pence: number | null | undefined): string | null {
  if (pence === null || pence === undefined) return null;
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP"
  }).format(pence / 100);
}

export function suggestedRetailPence(
  sourceCostPence: number,
  marginPercent: number
): number {
  return Math.round(sourceCostPence * (1 + marginPercent / 100));
}

export function canPublishPrice(product: Pick<
  Product,
  "sourceCostPence" | "retailPricePence" | "marginPercent" | "vatTreatment"
>): boolean {
  return (
    product.sourceCostPence !== null &&
    product.retailPricePence !== null &&
    product.marginPercent !== null &&
    product.vatTreatment !== "pending"
  );
}
